export default {
  text: {
    en: `
    Your gift has been already redeemed. Please log in to your account or contact our customer
    support at support@scentbird.com if believe that your gift was not redeemed.
  `,
  },
  buttonTitle: {
    en: 'Got it',
  },
}
